import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { SaveQuotation, GetQuotationsList, DeleteQuotation, CompleteQuotation, SendQuotationWhatsApp } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { LOOKUP_STALE_TIME } from "../Constant/AppConstants";

export const quotationQueryKeys = {
  quotationsList: () => ["quotationsList"] as const,
};

export const invalidateQuotationQueries = (queryClient: any) => {
  queryClient.invalidateQueries({ queryKey: ["quotationsList"] });
};

export const useQuotationsListQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: LOOKUP_STALE_TIME,
    ...options,
    queryKey: quotationQueryKeys.quotationsList(),
    queryFn: async () => unwrapApiResponse(await GetQuotationsList()),
  });
};

export const useSaveQuotationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof SaveQuotation>[0]) =>
      SaveQuotation(payload),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateQuotationQueries(queryClient);
      }
    },
  });
};

export const useDeleteQuotationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => DeleteQuotation(id),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateQuotationQueries(queryClient);
      }
    },
  });
};

export const useSendQuotationWhatsAppMutation = () => {
  return useMutation({
    mutationFn: (payload: Parameters<typeof SendQuotationWhatsApp>[0]) =>
      SendQuotationWhatsApp(payload),
  });
};

export const useCompleteQuotationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => CompleteQuotation(id),
    onSuccess: (res) => {
      if (res?.success) {
        invalidateQuotationQueries(queryClient);
      }
    },
  });
};
